import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=40204fd0&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=40204fd0&lang=less&scoped=true&"
import style1 from "./Preview.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40204fd0",
  null
  
)

export default component.exports